// Send Button
// ===========

const CLASS_ICON = 'icon';
const CLASS_SENDING = 'sending';
const DELAY = 200;

class SendButton {
    constructor(sendButtonElement) {
        this.button = sendButtonElement;
        this.delay = this.button.dataset.delay || DELAY;
    }

    start() {
        this.timeout = window.setTimeout(() => {
            this.button.tabIndex = -1;
            this.button.classList.add(CLASS_ICON, CLASS_SENDING);
        }, this.delay);
    }

    stop() {
        window.clearTimeout(this.timeout);
        this.button.tabIndex = 0;
        this.button.classList.remove(CLASS_ICON, CLASS_SENDING);
    }

    success() {
        window.clearTimeout(this.timeout);
        this.button.classList.remove(CLASS_SENDING);
        this.button.classList.add(CLASS_ICON, 'success');
        if (this.button.dataset.success) this.button.innerText = this.button.dataset.success;
    }
}

export default SendButton;
